import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  [dir='rtl'] &:after {\n    content: ' \\2190';\n  }\n  [dir='ltr'] &:after {\n    content: ' \\2192';\n  }\n"
    ], [
        "\n  [dir='rtl'] &:after {\n    content: ' \\\\2190';\n  }\n  [dir='ltr'] &:after {\n    content: ' \\\\2192';\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  width: 100%;\n\n  ",
        " {\n    transition: color ",
        ";\n  }\n\n  &:hover {\n    ",
        ", ",
        " {\n      color: ",
        ";\n    }\n  }\n\n  &:focus {\n    ",
        "\n  }\n\n  .focus-trap {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: center;\n\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Text, Link, Box } from "@miro-site/core";
import React from "react";
import styled from "styled-components";
export var CategoryLink = styled(Text).attrs(function(param) {
    var theme = param.theme;
    return {
        as: "div",
        $variant: "p1",
        $isDashed: false,
        $ml: [
            null,
            "auto",
            "auto",
            "auto"
        ],
        $nowrap: true,
        $styles: {
            fontWeight: 400,
            transition: "color ".concat(theme.animation.transitionDuration),
            color: theme.templates.colors.secondary40
        }
    };
}).withConfig({
    componentId: "sc-b7c2bfc5-0"
})(_templateObject());
var CategoryHeaderLink = styled(Link).withConfig({
    componentId: "sc-b7c2bfc5-1"
})(_templateObject1(), Heading, function(param) {
    var theme = param.theme;
    return theme.animation.transitionDuration;
}, Heading, CategoryLink, function(param) {
    var theme = param.theme;
    return theme.colors.primaryBlueHover;
}, function(param) {
    var theme = param.theme;
    return theme.normalizeStyles(_object_spread({}, theme.focus.outlines.withOffset));
});
var LinkWrapper = styled(Box).withConfig({
    componentId: "sc-b7c2bfc5-2"
})(_templateObject2());
var CategoryHeader = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var title = _param.title, viewAllLabel = _param.viewAllLabel, props = _object_without_properties(_param, [
        "title",
        "viewAllLabel"
    ]);
    return /*#__PURE__*/ _jsx(CategoryHeaderLink, _object_spread_props(_object_spread({
        ref: ref
    }, props), {
        children: /*#__PURE__*/ _jsxs(LinkWrapper, {
            children: [
                /*#__PURE__*/ _jsx(Heading, {
                    as: "h2",
                    $variant: [
                        "h3",
                        "h2",
                        "h2",
                        "h2"
                    ],
                    $mb: [
                        8,
                        null,
                        null,
                        null
                    ],
                    $align: "left",
                    $styles: {
                        maxWidth: [
                            null,
                            645,
                            645,
                            645
                        ]
                    },
                    children: title
                }),
                /*#__PURE__*/ _jsx(CategoryLink, {
                    children: viewAllLabel
                })
            ]
        })
    }));
});
CategoryHeader.displayName = "CategoryHeader";
export default CategoryHeader;
